import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState({
      account: state => state.account,
    }),
    ...mapGetters('account', ['isTopManager', 'isForeman']),
  },
};
